import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { GECKO_CONSTS, GeckoModal } from '../../';
import { EventEmitter } from 'fbemitter';
import { GeckoDialogService } from '../../';

import './dialog.scss';

class GeckoDialog extends Component {
  state = {
    modal: false,
    content: null,
    type: null,
    params: {},
  };

  constructor(props) {
    super(props);

    // Create toast event emitter (if not already created)
    if (!GeckoDialogService.emitter)
      GeckoDialogService.emitter = new EventEmitter();

    // Listen for open trigger
    GeckoDialogService.emitter.addListener('open', (content, type, params) => {
      this.setState({
        modal: true,
        content: content,
        type: type,
        params: params,
      });
    });

    // Listen for close trigger
    GeckoDialogService.emitter.addListener('close', () => {
      this.setState({
        modal: false,
        content: null,
        type: null,
        params: {},
      });
    });
  }

  renderBtns() {
    let btns = [
      {
        name: 'OK',
        primary: true,
        handler: () => GeckoDialogService.emitter.emit('close', true),
      },
    ];

    if (this.state.type === GECKO_CONSTS.DIALOG_TYPE_CONFIRM) {
      btns.push({
        name: 'Cancel',
        secondary: true,
        handler: () => GeckoDialogService.emitter.emit('close', false),
      });
    }

    return btns;
  }

  render() {
    if (!this.state.modal) return null;
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={() => {}}
        size={this.state.params.size}
        backdrop={this.state.params.backdrop}
        keyboard={this.state.params.keyboard}
        wrapClassName="gecko-modal-wrapper gecko-dialog"
      >
        <GeckoModal btns={this.renderBtns()} fields={[]} values={{}}>
          {this.state.content ? this.state.content : null}
        </GeckoModal>
      </Modal>
    );
  }
}

export default GeckoDialog;
